import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Meter = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 16 16"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1a8 8 0 013.875 15h-7.75A8 8 0 018 1zm4.53 12.53A6.364 6.364 0 0014.406 9H13V8h1.329a6.346 6.346 0 00-.665-2H12V5h1.004a6.372 6.372 0 00-3.005-2.089V4h-1V2.671a6.506 6.506 0 00-2 0V4h-1V2.911A6.384 6.384 0 002.994 5h1.004v1H2.334a6.346 6.346 0 00-.665 2h1.329v1H1.592c0 1.711.666 3.32 1.876 4.53.167.167.343.324.524.47h3.006l.571-8h.857l.571 8h3.006c.182-.146.357-.303.524-.47z"
  }));
});
Meter.displayName = 'Meter';
export var MeterDimensions = {
  height: 16,
  width: 16
};